module.exports = __webpack_public_path__ + "static/media/imaginxp-gamebanner.c6fc67bf.jpg";